import React, { useState, useEffect, useContext } from "react";
import { StoreContext } from "../store";
import * as Web3 from "web3";
import {
  BUSD_ADDRESS,
  STAKING_CONTRACT_ADDRESS,
  PHX_CONTRACT_ADDRESS,
  PHX_ADDRESS,
  USDT_CONTRACT_ADDRESS,
  USDT_ADDRESS,
  BNB_CONTRACT_ADDRESS,
} from "../constant";
import { WalletContext } from "../context/wallet";
import {
  BUSDABI,
  STAKING_POOL,
  PHXABI,
  PHX_STAKING_POOL,
  USDTABI,
  USDT_STAKING_POOL,
  BNB_STAKING_POOL,
} from "../abi";
import BigNumber from "bignumber.js";
import useClipboard from "react-use-clipboard";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

const StakeBox = (props) => {
  const { walletAddress, index } = props;

  let web3 = new Web3(window.web3?.currentProvider);

  // useEffect(() => {
  //   if (window.currentProvider) {
  //     web3 = new Web3(window.currentProvider);
  //   } else {
  //     web3 = new Web3(window.ethereum);
  //   }
  // }, [window.currentProvider]);

  const global = useContext(StoreContext);

  const getRewardUSDT = async () => {
    const USDT_depositContract = new web3.eth.Contract(
      USDT_STAKING_POOL,
      USDT_CONTRACT_ADDRESS
    );
    await USDT_depositContract.methods
      .withdrawReward(index)
      .send({ from: walletAddress });
  };

  const withDrawDepositUSDT = async () => {
    if (amount1 !== "0") {
      const USDT_depositContract = new web3.eth.Contract(
        USDT_STAKING_POOL,
        USDT_CONTRACT_ADDRESS
      );
      const samount = BigNumber(amount1).toString();
      console.log("amount1", amount1);
      await USDT_depositContract.methods
        .withdrawDeposit(amount1, index)
        .send({ from: walletAddress, gasLimit: 400000 });
    } else {
      alert("Please enter invalid number!");
    }
  };

  const approveUSDT = async () => {
    try {
      const USDTContract = new web3.eth.Contract(USDTABI, USDT_ADDRESS);
      const USDT_depositContract = new web3.eth.Contract(
        USDT_STAKING_POOL,
        USDT_CONTRACT_ADDRESS
      );
      const allowance = await USDTContract.methods
        .allowance(walletAddress, USDT_CONTRACT_ADDRESS)
        .call();
      if (parseInt(allowance) < amount * 10 ** 18)
        await USDTContract.methods
          .approve(
            USDT_CONTRACT_ADDRESS,
            BigNumber(amount * 10 ** 18)
              .toFixed()
              .toString()
          )
          .send({ from: walletAddress });
      console.log(referralAddress);
      console.log("USDT_depositContract", USDT_depositContract);
      if (referralAddress === "")
        await USDT_depositContract.methods
          .userDeposit(
            walletAddress,
            BigNumber(amount * 10 ** 18)
              .toFixed()
              .toString(),
            index
          )
          .send({
            from: walletAddress,
          });
      else
        await USDT_depositContract.methods
          .userDeposit(
            referralAddress,
            BigNumber(amount * 10 ** 18)
              .toFixed()
              .toString(),
            index
          )
          .send({
            from: walletAddress,
          });

      global.setLoad(true);
    } catch (err) {
      console.log(err);
    }
  };

  const [USDT_modalShow, setUSDT_ModalShow] = useState(false);
  const [USDT_modalShow1, setUSDT_ModalShow1] = useState(false);
  const [currentStake, setCurrentStake] = useState();
  const [USDT_reward, setUSDT_Reward] = useState();
  const [USDT_totalAmount, setUSDT_TotalAmount] = useState();
  const [USDT_tvl, setUSDT_TVL] = useState(0);
  const [USDT_withdrawAmount, setUSDT_WithdrawAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [amount1, setAmount1] = useState(0);
  const [USDT_balance, setUSDT_Balance] = useState(0);
  const [true_balance, setTrue_Balance] = useState(0);
  const [referralAddress, setReferralAddress] = useState("");
  const [freeTime, setFreeTime] = useState(0);

  useEffect(() => {
    if (!global.walletConnected) {
      initialize();
    }
  }, [global.walletConnected]);

  useEffect(() => {
    const getBalances = async () => {
      if (walletAddress === "" || walletAddress === null) {
        setUSDT_Balance(0);
      } else {
        // USDT
        const USDT_contract = new web3.eth.Contract(USDTABI, USDT_ADDRESS);
        const USDT_userBalance = await USDT_contract.methods
          .balanceOf(walletAddress)
          .call();
        setUSDT_Balance((USDT_userBalance / 10 ** 18).toFixed(18));
        setTrue_Balance((USDT_userBalance / 10 ** 18).toFixed(4));
      }
    };
    getBalances();
  }, [web3?.eth, walletAddress]);

  useEffect(() => {
    const getInit = async () => {
      const Url = window.location.href;
      let urls = Url.split("=");
      if (urls.length > 1 && urls[1] === "BONUS") {
        setReferralAddress("0xB770be217e2B446C546857e1109f2B0FB65af45C");
      } else if (urls.length > 1 && urls[1] === "GOLD") {
        setReferralAddress("0x767Ff070900F76bA9e3bfBC6Cd3B7c797d2ff1cf");
      } else if (urls.length > 1 && urls[1] !== "") {
        setReferralAddress(urls[1]);
      }

      // USDT POOL
      const USDTContract = new web3.eth.Contract(
        USDT_STAKING_POOL,
        USDT_CONTRACT_ADDRESS
      );
      let temp2 = await USDTContract.methods
        .calcWithdraw(walletAddress, index, true)
        .call({ from: walletAddress });
      setAmount1(temp2);
      setUSDT_WithdrawAmount(temp2 / (10 ** 18).toFixed(2));

      temp2 = await USDTContract.methods
        .calcReward(walletAddress, index)
        .call({ from: walletAddress });
      console.log("setUSDT_Reward", USDT_reward);
      setUSDT_Reward((temp2 / 10 ** 18).toFixed(2));
      console.log("setUSDT_Reward", temp2);
      temp2 = await USDTContract.methods
        .calcWithdraw(walletAddress, index, false)
        .call({ from: walletAddress });
      setUSDT_TotalAmount((temp2 / 10 ** 18).toFixed(2));
      temp2 = await USDTContract.methods
        .getFreeTime(walletAddress, index)
        .call({ from: walletAddress });
      console.log("getFreeTime", temp2, index);
      setFreeTime(temp2);

      // temp2 = await USDTContract.methods
      //   .getUserReferralCount(walletAddress)
      //   .call({ from: walletAddress });
      // setUSDT_ReferralCount(temp2);
      // temp2 = await USDTContract.methods
      //   .getTotalReferral(walletAddress)
      //   .call({ from: walletAddress });
      // setUSDT_ReferralAmount((temp2 / 10 ** 18).toFixed(2));
    };
    if (walletAddress !== "") getInit();
  }, [walletAddress, web3?.eth]);

  useEffect(() => {
    const init = async () => {
      // USDT
      const USDTContract = new web3.eth.Contract(
        USDT_STAKING_POOL,
        USDT_CONTRACT_ADDRESS
      );
      const USDT_tvl = await USDTContract.methods.getTotalDeposit(index).call();
      setUSDT_TVL(
        Number(USDT_tvl / 10 ** 18).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        })
      );
    };
    init();

    const intervalId = setInterval(() => {
      init();
    }, 1000 * 30); // in milliseconds
    return () => clearInterval(intervalId);
  }, [web3?.eth]);

  const initialize = () => {
    setUSDT_Balance(0);

    setUSDT_TotalAmount(0);

    setUSDT_Reward(0);
  };

  const item = props.item;

  return (
    <div className="col-12 col-lg-4 mb-3 ">
      <div className="staking staking-first">
        <div className="d-flex">
          <div>
            <img
              src="../../stake/staking-logo-blue.svg"
              // style={{ boxShadow: " 0px 1px -20px 0px rgba(0, 0, 0, 0.2)" }}
              alt=""
            />
          </div>
          <div className="staking__info staking__info_USDT align-self-center">
            {global.lan === false ? <h2>Stake RenQ</h2> : <h2>USDT Ферма</h2>}
            {global.lan === false ? (
              <p>Stake RenQ - {item.days}</p>
            ) : (
              <p>Инвестировать - Зарабатывать USDT</p>
            )}
          </div>
        </div>
      </div>
      <div className="staking-center">
        <div className="staking-apr ">
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <span className="staking-apr-letter">APY</span>
            </div>
            <span className="staking-apr-letter">
              {item.apy}%{/* <i className="mx-2 fa fa-calculator"></i> */}
            </span>
          </div>
          <div className="d-flex justify-content-between">
            <div className="d-flex">
              <span className="staking-apr-letter">Time</span>
            </div>
            <span className="staking-apr-letter">
              {item.days}
              {/* <i className="fa fa-question-circle-o"></i> */}
            </span>
          </div>
        </div>

        <div className="staking-main d-flex justify-content-between">
          <div className="staking-main-first">
            {global.lan === false ? (
              <>
                <p>Staked RenQ</p>
                {/* <>&plusmn;</> */}
              </>
            ) : (
              <p>Стейкинг USDT</p>
            )}
            <span>{USDT_totalAmount} RenQ</span>
          </div>
          <div>
            {item.status && (
              <button
                className="mobile_staking-plus-active"
                onClick={() => {
                  setUSDT_ModalShow(true);
                  setCurrentStake(item);
                }}
              >
                +
              </button>
            )}
            <button
              className="mobile_staking-plus"
              onClick={() => {
                setUSDT_ModalShow1(true);
                setCurrentStake(item);
              }}
            >
              -
            </button>
          </div>
        </div>
        <div className="staking-reward d-flex justify-content-between">
          <div className="staking-main-first">
            {global.lan === false ? <p>EARNED RenQ</p> : <p>Награда USDT</p>}
            <span>{USDT_reward} RenQ</span>
          </div>
          <div className="mobile_staking-plus-minus">
            {global.lan === false ? (
              <button
                className="mobile_staking-withdraw"
                onClick={getRewardUSDT}
              >
                Claim
              </button>
            ) : (
              <button
                className="mobile_staking-withdraw"
                onClick={getRewardUSDT}
              >
                Вывести
              </button>
            )}
          </div>
        </div>
        <div className="staking-note">
          <div className="d-flex justify-content-between mt-4">
            {global.lan === false ? (
              <span className="stake-slash">
                Total staked&nbsp;&nbsp; &nbsp;&nbsp;
              </span>
            ) : (
              <span
                className="stake-slash"
                style={{ fontSize: "13px !important" }}
              >
                Общий депозит&nbsp;&nbsp;--------------------------------
                &nbsp;&nbsp;
              </span>
            )}
            <span className="total-right d-flex" style={{ fontSize: "14px" }}>
              {" "}
              {USDT_tvl}
            </span>
          </div>
        </div>
        <div
          className="staking-main"
          style={{ marginBottom: "20px", textAlign: "right" }}
        >
          {/* {global.lan === false ? (
            <a
              href={
                "https://etherscan.io/address/" +
                0x664f8d425929b99c4cafb38d37a7e7d34ee57fb5
              }
              target="_blank"
              rel="noreferrer"
            >
              View Contract
            </a>
          ) : (
            <a
              href="https://etherscan.io/address/0x2dBF363f1244296E79455218928C475F95835Fc3"
              target="_blank"
              rel="noreferrer"
            >
              Посмотреть Контракт
            </a>
          )} */}
        </div>
      </div>
      <div className="section section--article section_article_mt">
        <WithdrawModal
          withdrawAmount={USDT_withdrawAmount}
          withDrawDeposit={withDrawDepositUSDT}
          setamount={setAmount1}
          amount={amount}
          show={USDT_modalShow1}
          global={global.lan}
          tokenname="RenQ"
          freeTime={freeTime}
          onHide={() => setUSDT_ModalShow1(false)}
        />
        <DepositModal
          approve={approveUSDT}
          balance={USDT_balance}
          true_balance={true_balance}
          setamount={setAmount}
          amount={amount}
          show={USDT_modalShow}
          global={global.lan}
          apy={currentStake}
          tokenname="RenQ"
          onHide={() => setUSDT_ModalShow(false)}
        />
      </div>
    </div>
  );
};

function DepositModal(props) {
  const {
    balance,
    true_balance,
    setamount,
    amount,
    approve,
    global,
    apy,
    tokenname,
  } = props;

  const handleConfirm = () => {
    props.onHide();
    approve();
  };

  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {global === false ? (
            <span className="modal-title">Stake {tokenname} Tokens</span>
          ) : (
            <span className="modal-title">Размещайте {tokenname} токены</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="busd-form d-flex flex-column">
          {global === false ? (
            <span className="text-right">
              {true_balance} {tokenname} Available
            </span>
          ) : (
            <span className="text-right">
              {balance} {tokenname} Доступно
            </span>
          )}
          <div style={{ textAlign: "right" }}>
            <input
              type="number"
              className="input-busd"
              value={amount}
              placeholder="0.00"
              onChange={(e) => setamount(e.target.value)}
            />
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <p style={{ margin: "0" }}>APY: {apy?.apy}%</p>
              <div>
                <button
                  className="max-amount"
                  onClick={() => setamount(balance)}
                >
                  Max
                </button>{" "}
                <span className="busd-symbol">{tokenname}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="modal-btn-group">
          {global === false ? (
            <Button className="cancel-btn" onClick={props.onHide}>
              Cancel
            </Button>
          ) : (
            <Button className="cancel-btn" onClick={props.onHide}>
              Отмена
            </Button>
          )}
          {global === false ? (
            <Button className="confirm-btn" onClick={handleConfirm}>
              Confirm
            </Button>
          ) : (
            <Button className="confirm-btn" onClick={handleConfirm}>
              Подтвердите
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

function WithdrawModal(props) {
  const {
    withdrawAmount,
    setamount,
    amount,
    withDrawDeposit,
    global,
    tokenname,
    freeTime,
  } = props;

  const [time, setTime] = useState(null);

  function unixTimeToRealTime(unixTime) {
    // if (unixTime == "0" || unixTime == "86400") {
    //   return;
    // }
    // Convert Unix timestamp to milliseconds
    const milliseconds = unixTime * 1000;

    // Create a new Date object using the milliseconds
    const dateObject = new Date(milliseconds);

    // Extract individual components of the date
    const year = dateObject.getFullYear();
    const month = dateObject.getMonth() + 1; // Months are 0-indexed, so we add 1
    const day = dateObject.getDate();
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const seconds = dateObject.getSeconds();

    // Format the date and time
    const formattedDate = `${year}-${month.toString().padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")}`;
    const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    // Return the formatted date and time
    setTime(`${formattedDate} ${formattedTime}`);
  }

  useEffect(() => {
    const currentTime = Number(Date.now() / 1000).toFixed(0);

    console.log("ttime", freeTime, currentTime);
    if (Number(freeTime) > currentTime) {
      unixTimeToRealTime(freeTime);
    }
  }, [freeTime]);

  const handleDeposit = () => {
    props.onHide();
    withDrawDeposit();
  };
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {global === false ? (
            <span className="modal-title">Withdraw {tokenname} Tokens</span>
          ) : (
            <span className="modal-title">Вывести {tokenname} токены</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="busd-form d-flex flex-column">
          {global === false ? (
            <span className="text-right">
              {withdrawAmount} {tokenname} Available
            </span>
          ) : (
            <span className="text-right">
              {withdrawAmount} {tokenname} Доступно
            </span>
          )}
          <div style={{ textAlign: "right" }}>
            {/* <input
              type="number"
              className="input-busd"
              value={amount}
              onChange={(e) => setamount(e.target.value)}
              placeholder="0.00"
            />
            <button
              className="max-amount"
              onClick={() => setamount(withdrawAmount)}
            >
              Max
            </button>{" "}
            <span className="busd-symbol">{tokenname}</span> */}
            <div style={{ display: "flex", justifyContent: "space-around" }}>
              {time && withdrawAmount ? (
                <p style={{ margin: "0" }}>Until: {time}</p>
              ) : (
                <p></p>
              )}
              <small style={{ marginLeft: "auto" }}>
                20% early withdraw fee
              </small>
            </div>
          </div>
        </div>
        <div className="modal-btn-group">
          {global === false ? (
            <Button className="cancel-btn" onClick={props.onHide}>
              Cancel
            </Button>
          ) : (
            <Button className="cancel-btn" onClick={props.onHide}>
              Отмена
            </Button>
          )}
          {global === false ? (
            <Button className="confirm-btn" onClick={handleDeposit}>
              Confirm
            </Button>
          ) : (
            <Button className="confirm-btn" onClick={handleDeposit}>
              Подтвердите
            </Button>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default StakeBox;
